/**
 * True when theme-supplied structured data actually contains JSON-LD to emit. An empty array or
 * empty object is truthy but carries nothing, so it must not suppress populated host JSON-LD.
 */
export const hasStructuredData = (data: unknown): boolean => {
  if (data === null || data === undefined) {
    return false;
  }
  if (Array.isArray(data)) {
    return data.length > 0;
  }
  if (typeof data === 'object') {
    return Object.keys(data).length > 0;
  }
  return false;
};

/**
 * Prevent user-authored content containing `</script>` from ending the script element.
 */
export const serializeJsonLd = (data: unknown): string =>
  JSON.stringify(data)
    .replace(/</g, '\\u003c')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
